<template functional>
  <div
    class="dataset-filter-company"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class]"
    :title="props.value"
  >
    <a
      @click="$options.onClick(props, listeners)"
      title="Click to filter"
    >
      {{ props.value }}
    </a>
  </div>
</template>

<script>
import router from '@/router'
import ModuleBase from './module-base'

export default {
  name: 'DatasetFilterCompany',
  mixins: [ModuleBase],
  onClick: (props, listeners) => {
    props.updateMeta({
      type: 'filter',
      context: [
        [ 'company', { type: 'id', data: props.row.CompanyId } ]
      ],
    })
  },
}
</script>

<style lang="scss">
@import '@/style/inject';

.dataset-cell-text-truncate {
  color: $beige;
}
</style>
